import { alpha2ToAlpha3 } from "@connect/i18n";
import type { FramesClient } from "@connect/data/frames/client";
import { log } from "@connect/observability";

/** Alpha-3 country of the customer's saved address, or null when unknown. */
export async function fetchCustomerCountry(client: FramesClient): Promise<string | null> {
  const res = await client.GET("/platform/v1/partner/customer/current").catch(() => null);

  if (!res || res.error) {
    // 404 = no profile on file (expected); anything else is unexpected.
    if (!res || res.response.status !== 404) {
      log.warn("Customer country request failed", {
        status: res?.response.status ?? "network_error",
      });
    }

    return null;
  }

  const country = res.data.customer.address?.country;

  return country ? alpha2ToAlpha3(country.toUpperCase()) : null;
}
